// extracted by mini-css-extract-plugin
module.exports = {"ProfileInfo":"ProfileInfo_ProfileInfo__1CNhr","ProfileTitle":"ProfileInfo_ProfileTitle__10qvT"};